import { connect } from 'react-redux';
import { rewritePath } from 'app/utils/routeUtils';

const withRewrite = connect(
  (state, { to: toProp }) => ({
    to: rewritePath(state.settings.rewriteRules)(toProp),
  }),
  {},
  null,
  {
    pure: false,
  },
);

export default withRewrite;
